<template>
  <div class="emp-training">
    <div class="search-bar">
      <span class="label">员工姓名：</span>
      <el-select
        v-model="selectedName"
        filterable
        clearable
        placeholder="请选择或搜索员工"
        style="width: 200px;"
        @change="onEmployeeChange"
      >
        <el-option
          v-for="item in employeeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <span class="label" style="margin-left:16px;">培训课程：</span>
      <el-input
        v-model="queryForm.trainingCourse"
        placeholder="请输入课程名称"
        clearable
        style="width: 160px;"
      />
      <el-button type="primary" icon="el-icon-search" style="margin-left:8px;" @click="fetchData">查询</el-button>
      <el-button type="success" icon="el-icon-plus" style="margin-left:8px;" @click="openAdd">新增</el-button>
    </div>

    <el-table :data="tableData" border v-loading="loading" style="margin-top:12px;">
      <el-table-column prop="personnelName" label="员工姓名" align="center" width="100" />
      <el-table-column prop="trainingCourse" label="培训课程" align="center" min-width="130" />
      <el-table-column prop="teacher" label="授课老师" align="center" width="100" />
      <el-table-column prop="trainingInstitution" label="培训机构" align="center" min-width="120" />
      <el-table-column prop="trainingDuration" label="培训时长" align="center" width="90" />
      <el-table-column label="培训结果" align="center" width="90">
        <template slot-scope="{ row }">
          <el-tag :type="row.examResults == 1 ? 'success' : 'danger'" size="small">
            {{ row.examResults == 1 ? '通过' : '未通过' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否获证" align="center" width="90">
        <template slot-scope="{ row }">
          <el-tag :type="row.isCertificate == 1 ? 'success' : 'info'" size="small">
            {{ row.isCertificate == 1 ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" plain @click="openEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top:12px; text-align:right;"
      :current-page="queryForm.pageNum"
      :page-size="queryForm.pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="onPageChange"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false">
      <el-form :model="form" label-width="110px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="员工姓名" required>
              <el-select v-model="form.personnelName" filterable placeholder="请选择员工" style="width:100%">
                <el-option v-for="item in employeeOptions" :key="item.value" :label="item.label" :value="item.label" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="培训课程" required>
              <el-input v-model="form.trainingCourse" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授课老师">
              <el-input v-model="form.teacher" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="培训机构">
              <el-input v-model="form.trainingInstitution" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="培训类型">
              <el-input v-model="form.trainingType" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="培训方式">
              <el-select v-model="form.trainingMethod" style="width:100%">
                <el-option label="非全日制" value="0" />
                <el-option label="全日制" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="培训时长">
              <el-input v-model="form.trainingDuration" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="培训地址">
              <el-input v-model="form.trainingLocation" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="培训结果">
              <el-select v-model="form.examResults" style="width:100%">
                <el-option label="未通过" value="0" />
                <el-option label="通过" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否获得证书">
              <el-select v-model="form.isCertificate" style="width:100%">
                <el-option label="否" value="0" />
                <el-option label="是" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书颁发单位">
              <el-input v-model="form.certificateUnit" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'EmpTraining',
  data() {
    return {
      employeeOptions: [],
      selectedName: '',
      queryForm: { trainingCourse: '', pageNum: 1, pageSize: 10 },
      tableData: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增培训经历',
      form: {
        id: '',
        personnelName: '', trainingCourse: '', teacher: '', trainingType: '',
        trainingMethod: '', trainingLocation: '', examResults: '',
        trainingInstitution: '', trainingDuration: '', isCertificate: '', certificateUnit: '',
      },
    };
  },
  created() {
    this.loadEmployees();
  },
  methods: {
    loadEmployees() {
      this.$postJson('uac/emp/queryUserListByEmpWithPage', {
        deptId: sessionStorage.getItem('groupId'),
        pageNum: 1,
        pageSize: 999,
      }).then((res) => {
        if (res && res.result && res.result.list) {
          this.employeeOptions = res.result.list.map((item) => ({
            label: item.userName,
            value: item.userName,
          }));
        }
      });
    },
    onEmployeeChange() {
      this.queryForm.pageNum = 1;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      this.$postJson('omc/personnelTrainingRecord/queryTrainingRecordDataAll', {
        data: {
          personnelName: this.selectedName || undefined,
          trainingCourse: this.queryForm.trainingCourse || undefined,
        },
        pageNum: this.queryForm.pageNum,
        pageSize: this.queryForm.pageSize,
      }).then((res) => {
        this.loading = false;
        if (res && res.result) {
          this.tableData = res.result.list || [];
          this.total = Number(res.result.total || 0);
        }
      }).catch(() => { this.loading = false; });
    },
    onPageChange(page) {
      this.queryForm.pageNum = page;
      this.fetchData();
    },
    openAdd() {
      this.dialogTitle = '新增培训经历';
      this.form = {
        id: '', personnelName: this.selectedName || '',
        trainingCourse: '', teacher: '', trainingType: '',
        trainingMethod: '', trainingLocation: '', examResults: '',
        trainingInstitution: '', trainingDuration: '', isCertificate: '', certificateUnit: '',
      };
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogTitle = '编辑培训经历';
      this.form = { ...row };
      this.dialogVisible = true;
    },
    submitForm() {
      if (!this.form.personnelName) { this.$message.error('请选择员工'); return; }
      if (!this.form.trainingCourse) { this.$message.error('请输入培训课程'); return; }
      const isEdit = !!this.form.id;
      const url = isEdit
        ? 'omc/personnelTrainingRecord/updateTrainingRecordData'
        : 'omc/personnelTrainingRecord/addTrainingRecordData';
      this.$postJson(url, this.form).then((res) => {
        if (res && res.code === 200) {
          this.$message.success(isEdit ? '修改成功' : '添加成功');
          this.dialogVisible = false;
          this.fetchData();
        }
      });
    },
  },
};
</script>

<style scoped>
.emp-training { padding: 16px; }
.search-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
.label { font-size: 14px; color: #606266; }
</style>
